import React from 'react';
import { TreeNodeDetail } from '../constants';

interface Props {
  nodesToDelete: TreeNodeDetail[];
  unableToDeleteNodes: TreeNodeDetail[];
  deleteTrips: boolean;
  isAnyExperimentAndContainerNode: boolean;
  isAnyContainerNode: boolean;
  imagesCount: number;
  showDetailedDeleteModal: boolean;
}
const DeleteModalConfirmationBody = (props: Props) => {
  const {
    nodesToDelete,
    unableToDeleteNodes,
    deleteTrips,
    isAnyExperimentAndContainerNode,
    isAnyContainerNode,
    imagesCount,
    showDetailedDeleteModal,
  } = props;
  return (
    <>
      {nodesToDelete.length > 0 && (
        <div id='explorer-deletemodalconfirmationbody-content'>
          {!showDetailedDeleteModal && (
            <>
              <text id='explorer-deletemodalconfirmationbody-maintext'>Are you sure you want to delete these files and its contents?</text>
              <br />
            </>
          )}
          {!deleteTrips &&
            !isAnyExperimentAndContainerNode &&
            showDetailedDeleteModal && (
              <>
                <text id="explorer-deletemodalconfirmationbody-basictext">Are you sure you want to delete these files and its contents?</text>
                <br />
              </>
            )}
          {deleteTrips
            ? 'When you delete this Synchrotron Trip, you cannot restore it, and crystal data will be lost.'
            : ''}

          {!deleteTrips && isAnyExperimentAndContainerNode && (
            <>
              <div id="explorer-deletemodalconfirmationbody-experimentcontainer-warning">
                {isAnyContainerNode && (
                  <text id="explorer-deletemodalconfirmationbody-container-warning">
                    This will delete all protein formulation, experiments, and images
                    under this folder.
                  </text>
                )}
                {isAnyExperimentAndContainerNode && showDetailedDeleteModal && (
                  <>
                    <text id="explorer-deletemodalconfirmationbody-step-images">
                      All images belonging to these experiment(s) will be removed.
                    </text>
                    <br />
                    <br />
                    <div id="explorer-deletemodalconfirmationbody-stepslist" className="ml-4">
                      <text id="explorer-deletemodalconfirmationbody-step1">1. Press Yes to delete.</text>
                      <br />
                      <text id="explorer-deletemodalconfirmationbody-step2">2. Press Cancel to abort this operation.</text>
                    </div>
                  </>
                )}
              </div>
              {!isAnyContainerNode &&
                isAnyExperimentAndContainerNode &&
                (nodesToDelete.length > 1 ? true : showDetailedDeleteModal) && (
                  <div id="explorer-deletemodalconfirmationbody-totalimg">Total Images(s): {imagesCount} </div>
                )}
            </>
          )}
          {nodesToDelete.map((node, index) => (
            <div id={`explorer-deletemodalconfirmationbody-nodeitem-${index}`}
             className="ml-6 mb-2" key={index}>{`${index + 1}) ${node.name}`}</div>
          ))}
        </div>
      )}
      {unableToDeleteNodes.length > 0 && (
        <div id="explorer-deletemodalconfirmationbody-unabledelete-title">
          These files cannot be deleted, hover to see details
          {unableToDeleteNodes.map((node, index) => (
            <div  id={`explorer-deletemodalconfirmationbody-unabledelete-item-${index}`}
              className="text-red-800 ml-4"
              key={index}
              title="You can't delete this synchrotron file because the file contains crystals and status is open"
            >{`${index + 1}) ${node.name}`}</div>
          ))}
        </div>
      )}
    </>
  );
};

export default DeleteModalConfirmationBody;
